module.exports = __webpack_public_path__ + "static/media/light-facebook-icon.0f210553.svg";